import React, {useState} from 'react';
import Markdown from 'react-markdown';

export default function ({message}) {
    const [formatting, setFormatting] = useState('md');

    const date = new Date(message.timestamp);

    function renderText(content_item, index) {
        if (formatting === 'html') {
            return (
                <div key={'html_' + index}
                     dangerouslySetInnerHTML={{__html: content_item.text.replaceAll("\n", "<br/>")}}/>
            );
        } else {
            return (
                <div key={'md_' + index}>
                    <Markdown allowElement={() => true}>{content_item.text}</Markdown>
                </div>
            );
        }
    }

    function renderImage(content_item, index) {
        return (
            <img
                key={index}
                src={content_item.image.source.s3Location ? content_item.image.source.s3Location.uri : btoa(content_item.image.source.bytes)}
                alt=''
                style={{
                    maxHeight: '170px'
                }}
            />
        );
    }

    function renderContentItem(content_item, index) {
        if (content_item.text) {
            return renderText(content_item, index);
        } else if (content_item.image) {
            return renderImage(content_item, index);
        }

        return (
            <div key={'error_' + index}>Error</div>
        );
    }

    function renderMessageContent(message) {
        if (message.role === 'user') {
            return (
                <>
                    <div className='d-flex flex-column'>
                        {message.content.map(renderContentItem)}
                    </div>
                    <i className="fas fa-2x fa-user"/>
                </>
            );
        } else {
            return (
                <>
                    <i className="fas fa-2x fa-robot"/>
                    <div className='d-flex flex-column'>
                        {message.content.map(renderContentItem)}
                    </div>
                </>
            );
        }
    }

    return (
        <div className={'d-flex justify-content-' + (message.role === 'user' ? 'end' : 'start')}>
            <div className={'d-flex flex-column align-items-' + (message.role === 'user' ? 'end' : 'start')}>
                <div className='d-flex bordered p-2 flex-gap-10 align-items-center"'>
                    {renderMessageContent(message)}
                </div>
                <div className='d-flex flex-gap-10 align-items-center'>
                    <label>{date.toLocaleDateString('en-US', {
                        month: 'long',
                        year: 'numeric',
                        day: 'numeric',
                        'hour': '2-digit',
                        'minute': '2-digit'
                    })}</label>
                    <div className='button-set'>
                        <button className='small' onClick={event => {
                            event.preventDefault();
                            setFormatting('md')
                        }}>
                            <span>MarkDown</span>
                            <span>&nbsp;</span>
                            {formatting === 'md' && <i className="fas fa-check"/>}
                        </button>
                        <button className='small' onClick={event => {
                            event.preventDefault();
                            setFormatting('html')
                        }}>
                            <span>HTML</span>
                            <span>&nbsp;</span>
                            {formatting === 'html' && <i className="fas fa-check"/>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
